import React, { Component } from 'react';
import { Navbar, Icon } from 'react-materialize';
import { Link } from 'react-router-dom';
import '../css/header.css';

class Header extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menuOpen: false
        };
        this.dropMenu = this.dropMenu.bind(this);
    }

    dropMenu() {
        if (this.state.menuOpen === false) {
            document.getElementsByClassName("hide-on-med-and-down")[0].style="height: 125px";
            this.setState({menuOpen: true});
        } else {
            document.getElementsByClassName("hide-on-med-and-down")[0].style="height: 0";
            this.setState({menuOpen: false});
        }
    }

  render() {
    return(
        <Navbar brand='ООО "Меридиан БКД"' right fixed>
            <Link to='/gallery'>Галерея</Link>
            <Link to='/types'>Типы ограждений</Link>
            <div>
                <button className='burger-btn' onClick={this.dropMenu}><Icon>menu</Icon></button>
            </div>

        </Navbar>

    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js